import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Box } from 'reflexbox';

import { useAuthenticatedUser, useFeature, useViewerRoles } from '@treams/treams-hooks';
import { FeatureName, PageType } from '@treams/treams-network';
import { Announcement, Jumbo, Tabs } from '@treams/treams-ui';

import { FeatureAnnouncements } from '../../packages/@treams/treams-app/src/pages/feature-announcements/FeatureAnnouncements';
import Journey from '../../packages/@treams/treams-app/src/pages/journey/Journey';
import GraphQLAnnouncement from '../announcements/Announcement';
import { InboxManagerContainerWithoutSidebar } from '../manager/inbox/InboxManagerContainer';
import { useManagerMode } from '../navigation/ManagerModeContext';
import { InboxPersonalContainerWithoutSidebar } from '../packages/kakapo-ui-application/pages/inbox/InboxPersonalContainer';

const HOME_CONTENT_WIDTH = 1000;

export default function Home() {
	const { t } = useTranslation();
	const authenticatedUser = useAuthenticatedUser();
	const { enabled } = useManagerMode();
	const { isWorkspaceSuperuser, isManager } = useViewerRoles();
	const hasAiConversationInsights = useFeature(FeatureName.ConversationAiInsights);
	const hasAiAgent = useFeature(FeatureName.AiAgent);

	if (enabled) {
		return <Redirect to="/manager" />;
	}

	return (
		<Box>
			<Announcement />
			{hasAiConversationInsights && hasAiAgent && (
				<GraphQLAnnouncement announcementID="32d2cdaf-dc8e-4bb8-a597-6c5cb2e7ff63" />
			)}
			{/* Transcription module announcement */}
			{/* {hasTranscriptions && (
				<GraphQLAnnouncement announcementID="b2dc7074-c0c8-4cb3-8474-0400ce3691e2" />
			)} */}
			<GraphQLAnnouncement announcementID="73026fea-dbbe-4edb-895f-94b87daaa169" />
			<Jumbo.Editable
				page={PageType.Home}
				hasMediaUpload
				wide={HOME_CONTENT_WIDTH}
				title={t('inbox.page.title', { name: authenticatedUser.firstName })}
				description={''}
				alternativePageTitle={t('home.page.title')}
				footer={
					<>
						<FeatureAnnouncements />
						<Tabs.Container wide={HOME_CONTENT_WIDTH}>
							<Tabs.Item title={t('inbox.tab.personal.title')} path="/" />
							{isWorkspaceSuperuser ? (
								<Tabs.Item title={t('inbox.tab.superuser.title')} path="/inbox/manager" />
							) : (
								isManager && (
									<Tabs.Item title={t('inbox.tab.manager.title')} path="/inbox/manager" />
								)
							)}
							<Tabs.Item title={t('inbox.tab.journey.title')} path="/journey" />
						</Tabs.Container>
					</>
				}
			/>
			<Switch>
				<Route path="/inbox/manager">
					<InboxManagerContainerWithoutSidebar header={false} />
				</Route>
				<Route path="/" exact>
					<InboxPersonalContainerWithoutSidebar header={false} />
				</Route>
				<Route path="/journey">
					<Journey jumbo={false} />
				</Route>
			</Switch>
		</Box>
	);
}
